'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiInfoLargeOutline = function TiInfoLargeOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.7 26.7l0.9-1.8c1.4-2.7 1.5-5.4 0.5-7.6-0.2-0.5-0.5-0.8-0.8-1.2 2.4-1 4-3.4 4-6.1 0-3.7-3-6.7-6.6-6.7s-6.7 3-6.7 6.7c0 1.3 0.4 2.5 1 3.5-2.8 0.6-4.6 2.1-4.9 2.3-1.2 1.1-1.4 2.8-0.6 4.2 0.5 0.9 1.4 1.5 2.4 1.6l-0.9 1.9c-1.3 2.7-1.5 5.4-0.4 7.6 0.9 1.9 2.7 3.2 4.9 3.7 0.7 0.1 1.4 0.2 2.1 0.2 4 0 6.6-2.3 6.9-2.5 1.2-1.1 1.5-2.8 0.7-4.2-0.5-0.9-1.5-1.5-2.5-1.6z m-2-20c1.8 0 3.3 1.5 3.3 3.3s-1.5 3.3-3.3 3.3c-1.9 0-3.4-1.5-3.4-3.3s1.5-3.3 3.4-3.3z m-3.1 25c-0.4 0-0.9-0.1-1.4-0.2-2.7-0.5-3.9-3.2-2.2-6.5l1.7-3.3c0.8-1.7 0.8-2.8-0.2-3.4-0.3-0.2-0.7-0.3-1.2-0.3-0.9 0-2 0.3-2 0.3s1.9-1.6 4.7-1.6c0.5 0 1 0 1.5 0.1 2.7 0.6 3.8 3.2 2.2 6.6l-1.7 3.3c-0.8 1.6-0.8 2.7 0.2 3.4 0.3 0.2 0.7 0.3 1.1 0.3 1 0 2-0.4 2-0.4s-1.9 1.7-4.7 1.7z' })
        )
    );
};

exports.default = TiInfoLargeOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/info-large-outline.js
// module id = 3628
// module chunks = 0